module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-subs"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.find_sub_for')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "select-subs__header"
  }, [_c('FilterUsers')], 1), _vm._v(" "), _c('div', {
    staticClass: "select-subs__header"
  }, [_c('input', {
    staticClass: "search-user",
    attrs: {
      "type": "search",
      "placeholder": _vm.$t('vue2.common.search_name_or_initials')
    },
    on: {
      "input": _vm.debounceSearch
    }
  })]), _vm._v(" "), _c('ul', [(_vm.usersSorted.length === 0) ? _c('li', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usersSorted), function(user, index) {
    return _c('li', {
      key: user.id,
      staticClass: "select-subs__sub shadow"
    }, [_c('div', {
      staticClass: "select-subs__sub__header"
    }, [_c('p', {
      staticClass: "select-subs__sub__name"
    }, [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('button', {
      staticClass: "bttn",
      on: {
        "click": function($event) {
          return _vm.addSub(user)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.select')) + "\n      ")])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c5facf7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsUserPanel/SubsUserPanelSubs2.vue
// module id = 1698
// module chunks = 1